import { useEffect, useState } from 'react';
import { clienteService } from '../../services/api';
import '../../styles/Clientes.css';
import { formatCurrency, formatPercent } from '../../utils/formatters';

const DetalleCliente = () => {
  const [clientes, setClientes] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [detalle, setDetalle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [busquedaCliente, setBusquedaCliente] = useState('');
  const [mostrarDropdown, setMostrarDropdown] = useState(false);
  const [clienteObj, setClienteObj] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const resp = await clienteService.getClientes({ per_page: 1000 });
        setClientes(resp.data?.clientes || []);
      } catch (e) {
        setError(e.response?.data?.error || 'No se pudo cargar la lista de clientes');
      }
    })();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.field')) {
        setMostrarDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const loadDetalle = async (id) => {
    if (!id) return;
    setLoading(true); setError('');
    try {
      const resp = await clienteService.getClienteDetalle(id);
      console.log('Detalle recibido:', resp.data || resp);
      console.log('Préstamos:', (resp.data || resp).prestamos);
      setDetalle(resp.data || resp);
    } catch (e) {
      setError(e.response?.data?.error || 'No se pudo cargar el detalle');
    } finally {
      setLoading(false);
    }
  };

  const clientesFiltrados = clientes.filter(cliente => {
    const termino = busquedaCliente.toLowerCase().trim();
    if (!termino) return true;

    return (
      (cliente.nombres && cliente.nombres.toLowerCase().includes(termino)) ||
      (cliente.apellidos && cliente.apellidos.toLowerCase().includes(termino)) ||
      (cliente.cedula && cliente.cedula.includes(termino)) ||
      (cliente.apodo && cliente.apodo.toLowerCase().includes(termino)) ||
      cliente.id.toString().includes(termino) ||
      (cliente.nombres && cliente.apellidos &&
       `${cliente.nombres} ${cliente.apellidos}`.toLowerCase().includes(termino))
    );
  }).slice(0, 10);

  const seleccionarCliente = (cliente) => {
    setClienteObj(cliente);
    setBusquedaCliente(`${cliente.nombres} ${cliente.apellidos} - ${cliente.cedula}`);
    setMostrarDropdown(false);
    setSelectedId(cliente.id);
  };

  const limpiarCliente = () => {
    setClienteObj(null);
    setSelectedId('');
    setBusquedaCliente('');
    setDetalle(null);
  };

  useEffect(() => {
    if (selectedId) loadDetalle(selectedId);
  }, [selectedId]);

  return (
    <div className="clientes-page">
      <div className="clientes-header">
        <h1>Detalle Cliente</h1>
      </div>

      <div className="card">
        <div className="field">
          <label>Cliente</label>
          <div style={{ position: 'relative' }}>
            <input
              type="text"
              className="form-control"
              placeholder="Buscar por nombre, cédula, apodo o ID..."
              value={busquedaCliente}
              onChange={(e) => {
                setBusquedaCliente(e.target.value);
                setMostrarDropdown(true);
              }}
              onFocus={() => setMostrarDropdown(true)}
            />
            {clienteObj && (
              <button
                type="button"
                onClick={limpiarCliente}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'transparent',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: '#6c757d'
                }}
              >
                ×
              </button>
            )}

            {mostrarDropdown && busquedaCliente && clientesFiltrados.length > 0 && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                backgroundColor: 'white',
                border: '1px solid #ddd',
                borderRadius: '4px',
                maxHeight: '400px',
                overflowY: 'auto',
                zIndex: 1000,
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
              }}>
                {clientesFiltrados.map((cliente) => (
                  <div
                    key={cliente.id}
                    onClick={() => seleccionarCliente(cliente)}
                    style={{
                      padding: '10px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #f0f0f0',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                  >
                    {cliente.foto_url ? (
                      <img
                        src={cliente.foto_url}
                        alt={cliente.nombres}
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          objectFit: 'cover'
                        }}
                      />
                    ) : (
                      <div style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        backgroundColor: '#007bff',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'bold'
                      }}>
                        {cliente.nombres?.charAt(0)}{cliente.apellidos?.charAt(0)}
                      </div>
                    )}
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 'bold' }}>
                        {cliente.nombres} {cliente.apellidos}
                        {cliente.apodo && (
                          <span style={{
                            marginLeft: '8px',
                            color: '#007bff',
                            fontStyle: 'italic',
                            fontWeight: 'normal'
                          }}>
                            ({cliente.apodo})
                          </span>
                        )}
                      </div>
                      <div style={{ fontSize: '0.9em', color: '#666' }}>
                        Cédula: {cliente.cedula} • ID: {cliente.id}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {error && <div className="banner error">{error}</div>}
      {loading && <div className="loading">Cargando…</div>}

      {detalle && (
        <div className="panel grid" style={{marginTop:'1rem'}}>
          <div className="card">
            <div className="card-title">Información del cliente</div>
            <div className="grid-2">
              <div className="field"><label>Apodo</label><div>{detalle.cliente.apodo || 'N/A'}</div></div>
              <div className="field"><label>Cédula</label><div>{detalle.cliente.cedula}</div></div>
              <div className="field"><label>Teléfono</label><div>{detalle.cliente.telefono || 'N/A'}</div></div>
              <div className="field"><label>Celular</label><div>{detalle.cliente.celular || 'N/A'}</div></div>
              <div className="field" style={{gridColumn:'1 / span 2'}}><label>Dirección</label><div>{detalle.cliente.direccion || 'N/A'}</div></div>
            </div>
          </div>

          <div className="card">
            <div className="card-title">Resumen financiero</div>
            <div className="grid-2">
              <div className="field"><label>Tomado</label><div>{formatCurrency(detalle.resumen.total_tomado)}</div></div>
              <div className="field"><label>Pagado</label><div>{formatCurrency(detalle.resumen.total_pagado)}</div></div>
              <div className="field"><label>Debe</label><div style={{color:'#c62828', fontWeight:600}}>{formatCurrency(detalle.resumen.total_debe)}</div></div>
            </div>
          </div>

          <div className="card" style={{gridColumn:'1 / span 2'}}>
            <div className="card-title">Préstamos</div>
            <table className="table">
              <thead>
                <tr>
                  <th>ID</th><th>Monto</th><th>Capital</th><th>Interés</th><th>Tasa</th><th>Modalidad</th><th>Estado</th>
                </tr>
              </thead>
              <tbody>
                {detalle.prestamos.map(p => (
                  <tr key={p.id}>
                    <td>{p.id || 'N/A'}</td>
                    <td>{formatCurrency(p.total)}</td>
                    <td>{formatCurrency(p.capital)}</td>
                    <td>{formatCurrency(p.interes)}</td>
                    <td>{formatPercent(p.tasa)}</td>
                    <td>{p.modalidad || 'N/A'}</td>
                    <td>{p.estado || 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default DetalleCliente;
